import { connect } from 'react-redux'	
import { RouteComponentProps } from 'react-router'	
import { ridersAddBonusToWallet } from '../../../state/actions/riders'	
import { IStoreState } from '../../../types/index'	
import AddBonusModal from '../../../components/riders/riderdetails/wallet/AddBonusModal'	

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {	
  return {	
    onClose: ownProps.history.goBack	
  }	
}	

export function mapDispatchToProps(dispatch: any) {	
  return {	
    addBonus: (riderId: string, amount: number, message: string = '') => {	
      return dispatch(ridersAddBonusToWallet(riderId, amount, message))	
    }	
  }	
}	

export default connect(	
  mapStateToProps,	
  mapDispatchToProps	
)(AddBonusModal)


// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/AddBonusModal.tsx